import { Box, useTheme, useMediaQuery } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CircleChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

type HeaderWithBackNavProps = {
    text: string;
    size: "lg" | "md" | "sm";
    target?: string
};

export default function HeaderWithBackNav({text, size, target = "-1"}: HeaderWithBackNavProps) {
    const navigate = useNavigate();
    const theme = useTheme();
    const isDesktop = useMediaQuery("(min-width:600px)");
    function onClickBack() {
        if(target === "-1") navigate(-1);
        else navigate(target);
    }
    let fontSize = "";
    let fontWeight = 200;
    switch (size) {
        case "lg":
            fontSize = isDesktop ? "4rem" : "1.75rem";
            fontWeight = 700;
            break;
        case "md":
            fontSize = isDesktop ? "2rem" : "1.75rem";
            fontWeight = 500;
    }

    return (
        <Box
            display={"flex"}
            width={"100%"}
            marginTop={2}
            marginBottom={2}
            alignItems={"center"}
            color={theme.palette.primary.light}
        >
            <Box
                display={"flex"}
                alignItems={"center"}
                marginRight={2}
                sx={{ cursor: "pointer" }}
                onClick={onClickBack}
            >
                <CircleChevronLeft size={size === "lg" ? "2.5rem" : "1.8rem"} />
            </Box>
            <Typography fontWeight={fontWeight} fontSize={fontSize}>
                {text}
            </Typography>
        </Box>
    );
}
